// Runtime configuration helper
// Only use runtime config if it has a non-empty value
const getRuntimeConfig = (key) => {
  if (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__) {
    const runtimeValue = window.__RUNTIME_CONFIG__[key];
    // Only use runtime config if it exists and is not empty
    if (runtimeValue && runtimeValue.trim() !== '') {
      return runtimeValue;
    }
  }
  // Fallback to build-time environment variable
  return process.env[key];
};

// API Base URLs
// Priority: Runtime config (if non-empty) > Build-time env variables
export const API_BASE_URL = getRuntimeConfig('REACT_APP_API_BASE_URL');
export const STATIC_BASE_URL = getRuntimeConfig('REACT_APP_STATIC_BASE_URL');
export const BASE_URL = getRuntimeConfig('REACT_APP_BASE_URL');

// Log config in development to help debug
if (process.env.NODE_ENV === 'development') {
  console.log('API Configuration:', {
    API_BASE_URL,
    STATIC_BASE_URL,
    BASE_URL,
    source: (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__ && 
             window.__RUNTIME_CONFIG__.REACT_APP_API_BASE_URL && 
             window.__RUNTIME_CONFIG__.REACT_APP_API_BASE_URL.trim() !== '') 
            ? 'runtime' : 'build-time (.env)',
    envValues: {
      REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
      REACT_APP_STATIC_BASE_URL: process.env.REACT_APP_STATIC_BASE_URL,
      REACT_APP_BASE_URL: process.env.REACT_APP_BASE_URL
    }
  });
}